import { createContext } from 'react';

import { useLocalStorageState } from '@/utils/use-local-storage-state';

import { LATEST_ORGANIZATION_STORAGE_KEY } from './constants';

type OrgIdContextType = {
  orgId: string;
  setOrgId: React.Dispatch<React.SetStateAction<string>>;
};

const OrgIdContext = createContext<OrgIdContextType | null>(null);

const OrgIdContextProvider = ({ children }) => {
  const [orgId, setOrgId] = useLocalStorageState(
    LATEST_ORGANIZATION_STORAGE_KEY,
    ''
  );

  return (
    <OrgIdContext.Provider
      value={{
        orgId,
        setOrgId,
      }}
    >
      {children}
    </OrgIdContext.Provider>
  );
};

export { OrgIdContext, OrgIdContextProvider };
